inputs-complex-checkbox-phase
  div(class="form-group row { error: opts.errors }")
    label.col-md-4.col-form-label
      | {opts.label}
      span.text-danger(if="{ opts.required }") &nbsp;*
    .col-md-8
      span.checkbox-wrap.phase-wrap(each="{ item, index in this.opts.items }" style="border-bottom:5px solid {item.colorcode}")
        input(if="{ item.checked }"  id="{this.tagScope}_{index}" type="checkbox" value="{ item.value }" name="{parent.opts.name}" onChange="{ parent.onChange }" checked="checked")
        input(if="{ !item.checked }" id="{this.tagScope}_{index}" type="checkbox" value="{ item.value }" name="{parent.opts.name}" onChange="{ parent.onChange }")
        label(for="{this.tagScope}_{index}") { item.label }
      div.help-block(if="{ opts.errors }")
        ul(role="alert")
          li.text-danger.error(each="{message in opts.errors}") { message }
  script(type="typescript").
    this.mixin('inputs.complex.checkbox-phase');
  style(scoped).
    label {
      padding: 0 1rem 0 .5rem;
    }
